import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { UserRole } from '../types';
import { useTheme } from '@flowcore-water/ui';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { t } = useTheme();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="" style={{ color: t.textMuted }}>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // outside_observer can view all routes (read-only enforced at component level)
  if (requiredRole && user.role !== 'outside_observer' && !requiredRole.includes(user.role)) {
    return <Navigate to="/tree" replace />;
  }

  return <>{children}</>;
};
